import { updateTitle } from "../actions";

const updateTitleThunk = (todoId, text) => {
  return async (dispatch) => {
    const response = await fetch(`https://ranok-fake-server.herokuapp.com/todos/${todoId}`, {
      method: "PATCH",
      body: JSON.stringify({
        text: text,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const todo = await response.json();
    dispatch(updateTitle(todo.id, todo.text));
  };
};

export default updateTitleThunk;
